import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthSession } from "../../shared";
import {
  getMerchantRegistrationRedirect,
} from "../utils/merchantOnboarding";
import { MerchantOnboardingSessionRecovery } from "./MerchantOnboardingSessionRecovery";

interface MerchantRegistrationRouteGuardProps {
  children: React.ReactNode;
}

/** Enforces authentication, role, completion, and required-step registration policy. */
export const MerchantRegistrationRouteGuard: React.FC<MerchantRegistrationRouteGuardProps> = ({
  children,
}) => {
  const { pathname } = useLocation();
  const { user, isLoggedIn, merchantOnboardingStage } = useAuthSession();

  if (isLoggedIn && user?.role === "merchant") {
    return (
      <MerchantOnboardingSessionRecovery requestedPath={pathname}>
        {children}
      </MerchantOnboardingSessionRecovery>
    );
  }

  const redirectTo = getMerchantRegistrationRedirect({
    isLoggedIn,
    role: user?.role,
    requestedPath: pathname,
    onboardingStage: merchantOnboardingStage,
  });

  if (redirectTo) {
    return (
      <Navigate
        to={redirectTo}
        replace
      />
    );
  }

  return <>{children}</>;
};
